<template>
  <div class="box4">
    <pageTitle title="真实学员案例" tit />
    <div class="title common-animation">
      学习课程后他们成功涨粉50w+，多条视频播放100w+
    </div>

    <div class="content common-animation">
      <div class="swiper-button-prev1"></div>
      <div class="swiper-button-next1"></div>

        <swiper :options="swiperOption" ref="mySwiper1">
          <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="block" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
              <img :src="require(`../../../assets/topic-page/newMedia2/box4/${index +
                1}.png`)
                " alt />

              <div class="text-box">
                <p>
                  帐号类型：
                  <br />
                  {{ item.type }}
                </p>
                <p>
                  粉丝情况：
                  <br />
                  {{ item.num }}
                </p>
              </div>
            </div>
          </swiper-slide>
        </swiper>
    </div>

    <div class="title title1 common-animation">
      按照老师的指导，他们突破瓶颈，掌握引流变现技巧
    </div>
    <div class="content2 common-animation">
      <div class="swiper-button-prev1"></div>
      <div class="swiper-button-next1"></div>
      <swiper :options="swiperOption2" ref="mySwiper2">
        <swiper-slide v-for="(item, index) in demo" :key="index">
          <div class="block" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
            <img :src="require(`../../../assets/topic-page/newMedia2/box4/0${index +
              1}.png`)
              " alt />

            <div class="text-box text-box1">
              <p>
                <br />
                {{ item.type }}
              </p>
              <p>
                <br />
                {{ item.num }}
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="btn" @click="childMethod">了解更多学员案例</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import pageTitle from "../../../components/common/pageTitle.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        loop: true, //是否循环
        slidesPerView: "3",
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        spaceBetween: 40, //  每张图片之间的间隔
        navigation: {
          nextEl: ".content .swiper-button-next1",
          prevEl: ".content .swiper-button-prev1"
        }
      },
      swiperOption2: {
        loop: true, //是否循环
        slidesPerView: "3",
        spaceBetween: 20, //  每张图片之间的间隔
        navigation: {
          nextEl: ".content2 .swiper-button-next1",
          prevEl: ".content2 .swiper-button-prev1"
        }
      },
      list: [
        {
          type: "测评类账号",
          num: "学习课程后涨粉至20w+"
        },
        {
          type: "搞笑人设IP",
          num: "学习课程后涨粉至26w+"
        },
        {
          type: "独立剪辑师人设IP",
          num: "单月最高涨粉10w, 目前粉丝22w+"
        },
        {
          type: "口播人设IP",
          num: "单个作品发布后涨粉50w，粉丝总数68w+"
        },

        {
          type: "自用好物分享，宝藏店铺安利",
          num: "学习课程后涨粉38.5w，粉丝总数93w+"
        },
        {
          type: "美食制作分享账号",
          num: "学习课程后涨粉至4w+"
        }
      ],
      demo: [
        {
          type: "测评类账号，刚报名课程时2w+粉丝",
          num: "目前粉丝20w+，单条星图广告报价8000"
        },
        { type: "宝妈好物分享类账号", num: "目前粉丝64w+，月自然流佣金2w+" },
        { type: "宝妈好物分享类账号", num: "单日佣金可达3000+" },
        {
          type: "直播带货类账号，每天直播1小时",
          num: "目前累计带货额可达25w--50w"
        },
        {
          type: "70后美食分享类账号",
          num: "2周变现数据近10个W，小店随心推条条爆"
        },
        { type: "95后美妆分享类账号", num: "月自然佣金2600+" },
        { type: "美食家具类账号", num: "月成交订单数5w+，每月都有爆款" },
        { type: "测评类账号，月佣金1w+", num: "多平台同时运营，多渠道开花" }
      ]
    };
  },
  methods: {
    on_bot_enter() {
      this.$refs.mySwiper1.$el.swiper.autoplay.stop();
      this.$refs.mySwiper2.$el.swiper.autoplay.stop();
    },
    on_bot_leave() {
      this.$refs.mySwiper1.$el.swiper.autoplay.start();
      this.$refs.mySwiper2.$el.swiper.autoplay.stop();
    },
    goLeft(type) {
      type === 1
        ? this.$refs.mySwiper1.$swiper.slidePrev()
        : this.$refs.mySwiper2.$swiper.slidePrev();
    },
    goRight(type) {
      type == 1
        ? this.$refs.mySwiper1.$swiper.slideNext()
        : this.$refs.mySwiper2.$swiper.slideNext();
    },
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="scss" scoped>
.box4 {
  margin: 0 auto;
  padding: 80px 0px;
  max-width: 2048px;
  background: url("../../../assets/topic-page/newMedia2/box4/bg.jpg") no-repeat;
  background-size: cover;
  background-position-x: center;
  box-sizing: border-box;
  .btn{
      width: 247px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg2.png") no-repeat;
      cursor: pointer;
      margin: 10px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .swiper-button-prev1 {
    position: absolute;
    left: -30px;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    box-shadow: 0px 10px 20px 0px #f6edf0;
    border-radius: 50%;
    background-image: url("../../../assets/topic-page/newMedia2/box4/left.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    box-shadow: 0px 10px 20px 0px #f6edf0;
    z-index: 10;
    cursor: pointer;

    &::after {
      content: "";
    }

    &:hover {
      background-image: url("../../../assets/topic-page/newMedia2/box4/left-c.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }

  .swiper-button-next1 {
    position: absolute;
    right: -28px;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 0px 10px 20px 0px #f6edf0;
    width: 48px;
    z-index: 10;
    height: 48px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px #e0edff;
    border-radius: 50%;
    background-image: url("../../../assets/topic-page/newMedia2/box4/right.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    box-shadow: 0px 10px 20px 0px #f6edf0;
    cursor: pointer;

    &::after {
      content: "";
    }

    &:hover {
      background-image: url("../../../assets/topic-page/newMedia2/box4/right-c.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }

  .title {
    position: relative;
    margin-top: 50px;
    font-family: PingFang-SC-Bold;
    font-size: 22px;
    line-height: 36px;
    letter-spacing: 1px;
    text-align: center;
    color: #ff3377;

    &::after {
      position: absolute;
      left: 50%;
      top: 30px;
      transform: translate(-50%, 0px);
      content: "";
      width: 1200px;
      height: 20px;
      background: url("../../../assets/topic-page/newMedia2/box4/title.png") no-repeat;
      background-size: cover;
    }
  }

  .title1 {
    &::after {
      position: absolute;
      left: 50%;
      top: 20px;
      transform: translate(-50%, 0px);
      content: "";
      width: 1200px;
      height: 20px;
      background: url("../../../assets/topic-page/newMedia2/box4/title1.png") no-repeat;
      background-size: cover;
    }
  }

  .content {
    position: relative;
    margin: 0 auto;
    margin-top: 60px;
    padding-bottom: 30px;
    width: 1200px;

    .swiper-slide {
      width: 285px;
      height: 520px;
      border-radius: 10px;
    }
  }

  .block {
    position: relative;
    width: 370px;
    height: 513px;

    .text-box {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: absolute;
      bottom: 0px;
      border-radius: 0px 0px 10px 10px;
      width: 100%;
      /* padding-top: 34px; */
      transition: 0.5s all;
      height: 0;
      background-image: linear-gradient(180deg, #ff99bb 0%, #ff6699 100%);
      box-sizing: border-box;
      overflow: hidden;

      p {
        padding-left: 25px;

        font-family: PingFang-SC-Regular;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 0px;
        color: #ffffff;
        padding-bottom: 38px;
      }

      // transform: translateY(286px);
      opacity: 1;
      transition: 0.5s all;

      p:first-child {
        margin-bottom: 26px;
        padding-bottom: 0;
      }
    }

    img {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
    }

    &:hover {
      .text-box {
        height: 185px;
        // transform: translateY(0px);
      }
    }
  }

  .content2 {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 50px;
    width: 1200px;
    position: relative;

    .block {
      position: relative;
      width: 386px;
      height: 287px;
      // border: solid 4px #bfb2ff;
      box-sizing: border-box;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .text-box1 {
      p {
        margin-bottom: 0 !important;
        width: 100%;
        line-height: 18px !important;
      }
    }

    .block {
      &:hover {
        .text-box1 {
          height: 135px !important;
        }
      }
    }
  }

}
</style>
